/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getGetAPIMethod, getPostAPIMethod } from "@neum/frontend-shared/utils/api";

// Notes APIs
export const getNotesMetadata = getGetAPIMethod(
    "/v2/notes_metadata/{session_id}",
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
);

export const downloadSoapNoteData = getGetAPIMethod(
    "/v2/soap_note/{session_id}/{node_id}",
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
);

export const processDocuments = getPostAPIMethod(
    "/v1/process_documents",
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
);

// Recording APIs
export const registerRecording = getPostAPIMethod(
    "/v1/register_recording",
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
)
